import { render, staticRenderFns } from "./Pendientes.vue?vue&type=template&id=00bf4898"
import script from "./Pendientes.vue?vue&type=script&lang=ts"
export * from "./Pendientes.vue?vue&type=script&lang=ts"
import style0 from "./Pendientes.vue?vue&type=style&index=0&id=00bf4898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports